<template>
    <select class="select2" :id="'select2-' + id" :multiple="multiple">
        <optgroup v-if="hasChildren" v-for="option in options" :label="option[labelKey]">
            <option v-for="child in option[childKey]" :value="child[valueKey]">{{child[labelKey]}}</option>
        </optgroup>
        <option v-else v-for="option in options" :value="option[valueKey]">{{option[labelKey]}}</option>
    </select>
</template>

<script>
    export default {
        name: "Select2",

        props: {
            valueKey: {
                type: String,
                default: 'id'
            },
            labelKey: {
                type: String,
                default: 'name'
            },
            childKey: {
                type: String,
                default: 'children'
            },
            selectOptions: {
                type: Object,
                default: function(){
                    return {};
                }
            },
            id: {
                type: [Number,String],
                default: Math.random().toString(36).substr(2, 9)
            },
            options: {
                type: [Array,Object]
            },
            multiple: {
                type: Boolean
            },
            hasChildren: {
                type: Boolean,
                default: false
            }
        },

        mounted(){
            let self = this;
            $('#select2-' + this.id).select2(this.selectOptions).change(function(){
                self.$emit('input', $(this).val());
            });
        }
    }
</script>
